
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nutrition-for-kids",
      function () {
        return require("private-next-pages/nutrition-for-kids/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nutrition-for-kids"])
      });
    }
  